/**
 * Modal
 * *
 */


const FOCUSABLE_ELEMENTS = '[href], input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]):not(.modal__close-button), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary';

export default {
  modals: [],

  init() {
    const $modalItems = document.querySelectorAll('.js-modal');
    $modalItems.forEach($item => this.modals.push(new Modal($item)));
    this.addEscapeListener();
  },

  addEscapeListener() {
    document.addEventListener("keydown", (e) => {
      // if escape key is pressed
      if(e.key === "Escape") {
        this.modals.forEach(modal => modal.close());
      }
    });
  },
}

class Modal {
  constructor($element) {
    if (!($element instanceof HTMLElement)) return;
    this.$modal = $element;
    this.$closeButton = this.$modal.querySelector('.modal__close-button');
    this.triggers = document.querySelectorAll('[aria-controls="'+this.$modal.getAttribute('id')+'"]');
    this.show = false;
    this.allFocusableElements = this.$modal.querySelectorAll(FOCUSABLE_ELEMENTS);
    this.$closeButton.addEventListener('click', this.close.bind(this));
    this.clickedTrigger = null

    this.$modal.addEventListener('click', (event) => {
      if (this.$modal === event.target) this.close();
    });

    this.addTriggerListeners();
    this.moveModalToFooter();
  }

  moveModalToFooter() {
    document.body.appendChild(this.$modal);
  }

  addTriggerListeners() {
    if ( this.triggers ) {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', event => {
          this.clickedTrigger = trigger;
          event.preventDefault();
          if (this.show) {
            this.close();
          } else {
            this.open();
          }
        });
      });
    }
  }

  setFocusOnFirstElement() {
    if(this.allFocusableElements.length > 0) {
      // wait for the end of transitions before moving focus
      this.$modal.addEventListener("transitionend", () => {
        this.allFocusableElements[0].focus();
      }, {once: true});
    }
  }

  setFocusBack() {
    if (this.clickedTrigger) {
      this.clickedTrigger.focus();
    }
  }

  setFocusModalTrap() {

  }

  close() {
    document.body.style.overflow = "auto";
    this.$modal.classList.remove('modal-is-open');
    this.show = false;
    this.setFocusBack();
  }

  open() {
    document.body.style.overflow = "hidden";
    this.show = true;
    this.$modal.classList.add('modal-is-open');
    this.setFocusOnFirstElement();
  }
}
